import { type CuratedStory, type Image, ZoneColumnCombo } from "~types/types";
import {
    type IntegrityStatus,
    checkItemArrayIntegrity,
    firstItemOnly,
} from "~utils/moduleIntegrity";

interface SingleStoryImageRightIntegrityProps {
    items?: CuratedStory[];
    image?: Image;
    renderingLocation?: ZoneColumnCombo;
}

export default function integrityCheck({
    items = [],
    image,
    renderingLocation,
}: SingleStoryImageRightIntegrityProps): IntegrityStatus {
    const messages = checkItemArrayIntegrity(firstItemOnly(items));

    if (items?.length) {
        const [{ type, byline, image: contentImage }] = items;

        if (!image?.baseUrl && !contentImage?.baseUrl) {
            messages.push("Missing image baseUrl");
        }

        if (
            type !== "article" &&
            renderingLocation !== ZoneColumnCombo.rightRail &&
            !byline
        ) {
            messages.push("Missing byline");
        }
    }

    return messages;
}
